import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspacesApi as r } from "@maat/api-main";
import { authQueryKeys as i } from "@maat/store-auth";
//#region src/workspaces/useCreateWorkspaceMutation.ts
var a = () => {
	let a = n();
	return t({
		mutationFn: r.createWorkspace,
		onSuccess: () => {
			a.invalidateQueries({ queryKey: e.list() }), a.invalidateQueries({ queryKey: i.state() });
		}
	});
};
//#endregion
export { a as useCreateWorkspaceMutation };
